import { render, staticRenderFns } from "./question-reset.vue?vue&type=template&id=1274bbce"
import script from "./question-reset.vue?vue&type=script&lang=js"
export * from "./question-reset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports